export default [
      {
    fileName: "client/client4.jpg",
    link:
      "#",
    category: "Banner",
    action: "Click",
    label: "beneficiar_inchidere_upmobilpay",
  },
  {
        fileName: "beneficiary/beneficiar.jpg",
        link:
            "https://upmoldova.md/harta-afiliati/",
        category: "Banner",
        action: "Click",
        label: "utilizatori",
    },
];
